import { View } from "ui/atoms/view";
import { Button, ButtonIcon } from "ui/gluestack/button";
import { MessageCircleIcon } from "ui/gluestack/icon";

type Props = {
  onPress: () => void;
};

const AddConcernCommentAction: React.FC<Props> = ({ onPress }) => {
  return (
    <View>
      <Button variant="link" size="sm" onPress={onPress}>
        <ButtonIcon as={MessageCircleIcon} className="w-5 h-5" />
      </Button>
    </View>
  );
};

export default AddConcernCommentAction;
